import { Navigate } from 'react-router-dom';
import { useAuth } from '../services/authentication/authContext';
import { canAccessCostPercentPage } from '../services/accessManagement/accessManagement';

/**
 * Gates the Cost Percent (Inslag) pages behind the per-account `cost_percent_page`
 * flag (admin-only while in testing; force-on for impersonating super admins).
 * Redirects to the dashboard when the account does not have the feature.
 */
export function CostPercentRoute({ children }: { children: JSX.Element }) {
  const { backendUser, accountSettings } = useAuth();
  if (!canAccessCostPercentPage(backendUser, accountSettings)) {
    return <Navigate to="/dashboard" replace />;
  }
  return children;
}
